import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetScheduleParams } from '../../../ts/ServerApi/types/actionParams';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetDataAccelerationTasksScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setDataAccelerationTasksSchedule', {
      ids: ids,
      scheduleId: scheduleId
    });
  }
}
